















import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/NavBar.vue";
import router from "@/router";

@Component({
  components: {
    NavBar
  }
})
export default class App extends Vue {
  constructor() {
    super();
  }
}
